import react from "../assets/react.png";
import angular from "../assets/angular.png";
import shop from "../assets/shop.jpg";

const Projects = [
  {
    name: "React Portfolio",
    link: "https://Rayhaha.github.io/MyWebsite",
    imageSrc: react,
    content: "A performant, accessible, progressive React portfolio.",
    githubLink: "https://github.com/RayHaha/MyWebsite",
  },
  {
    name: "Angular Portfolio",
    link: "https://yu-jui-chang-website.web.app/",
    imageSrc: angular,
    content: "My personal website made by Angular.",
    githubLink: "https://github.com/RayHaha/PersonalWebpage",
  },
  {
    name: "Shop",
    link: "https://angular-weapon-store.web.app",
    imageSrc: shop,
    content: "A website implementing an online store",
    githubLink: "https://github.com/RayHaha/Angular.js-weapon-store",
  },
];

export default Projects;
